var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"skeleton","mode":"out-in","css":_vm.transition && _vm.hasChild ? true : false}},[_c('div',[(_vm.isLoaded)?_vm._t("default"):_c('span',_vm._l((_vm.rep),function(index){return _c('span',{key:index,class:_vm.componentClass,style:(_vm.componentStyle)})}),0)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }